import { z } from 'zod';
import { reportingExecutionRequestSchema, reportingExecutionResponseSchema } from './reporting-finance-project-performance.contract.js';
export const reportingCsvExportCapability = 'reporting.csv-exports.v1';
export const reportingCsvExportRequestSchema = reportingExecutionRequestSchema;
export const reportingCsvArtifactSchema = z.strictObject({
    fileName: z.string().trim().min(1).max(180),
    contentType: z.literal('text/csv; charset=utf-8'),
    csv: z.string().min(1).max(5_242_880),
    byteLength: z.number().int().positive().max(5_242_880),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
    rowCount: z.number().int().nonnegative().max(500),
    truncated: z.boolean(),
});
export const reportingCsvExportResponseSchema = z.strictObject({
    data: z.strictObject({
        execution: reportingExecutionResponseSchema.shape.data,
        artifact: reportingCsvArtifactSchema.nullable(),
    }),
});
//# sourceMappingURL=reporting-csv-export.contract.js.map